import React, { useEffect, useRef, useCallback } from "react";
import SelectInputMap from "../../../../InputForms/SelectInputMap/SelectInputMap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import { setRoadmap, setRoadmaps } from "../../../../../../../pages/Map/store/mapScreenSlce";

const InputSelectRoadmap = ({ isLoadingRoadmaps, options, onChange, isDisabled = false }) => {
  const { roadmap } = useSelector((state: RootState) => state.mapScreen);
  const dispatch = useDispatch();

  const prevRoadmapRef = useRef(roadmap);

  const onClear = useCallback(() => {
    dispatch(setRoadmap(undefined));
    dispatch(setRoadmaps([]));
    // dispatch(setBusStations([]));
  }, [dispatch]);

  useEffect(() => {
    const prev = prevRoadmapRef.current;

    // Был маршрут -> стал очищен
    if (prev && !roadmap) {
      onClear();
    }

    prevRoadmapRef.current = roadmap;
  }, [roadmap, onClear]);

  return (
    <SelectInputMap
      selectedValue={roadmap ? { value: roadmap.route_id.toString(), label: roadmap.route_name } : null}
      placeholder="Выберите маршрут"
      isLoading={isLoadingRoadmaps}
      options={options}
      onChange={onChange}
      onSearchChange={onChange}
      onClear={onClear}
      initSelectedValue={roadmap ? { value: roadmap.part_id, label: roadmap.route_name } : undefined}
      isDisabled={isDisabled}
    />
  );
};

export default InputSelectRoadmap;